export const translationEn = {
  shared: {
    error: {
      base: 'An error occurred',
      invalidRequest: 'Invalid request content',
      required: 'Required field',
      email: 'Invalid email',
      minSixLetter: 'Minimum 6 characters',
      copy: 'An error occurred while copying',
      data: 'An error occurred while loading data',
      video: 'Your browser does not support the video tag',
      timeSessionExpired: 'Session timed out',
      download: 'An error occurred while downloading the file',
    },
    message: {
      copy: 'Copied',
    },
    text: {
      yes: 'Yes',
      no: 'No',
      empty: 'No data',
      upTo: 'Up to',
      checkConnectionAndTryAgain:
        'Check your internet connection and try again',
      repeat: 'Try again',
      noData: 'No data',
      continue: 'Continue',
      back: 'Back',
      finish: 'Done',
      ok: 'OK',
    },
    plural: {
      days_one: '{{count}} day',
      days_other: '{{count}} days',
      months_one: '{{count}} month',
      months_other: '{{count}} months',
    },
  },
  installation: {
    finish: "Congratulations! You have successfully installed Private Gate VPN!",
  },
  theme: {
    toggle: 'Switch theme',
  },
  banner: {
    premiumExpiration: {
      title: 'Hello👋',
      subtitle:
        'Just a gentle reminder that your Premium subscription will expire in {{count}} days.',
      description: 'Renew now to avoid any interruptions 👇',
      button: 'Renew Premium',
    },
    premiumExpiration_1: {
      title: 'Hi ⏳ Your Premium subscription expires tomorrow.',
      subtitle: `Imagine how much you could lose by going back to the free version: The current VPN on X-Ray technology, which can't be blocked, will stop working.
        
        Renewing now ensures you continue to have secure and unlimited internet access. Make the choice in favour of your convenience and security.
        `,
      description: `Renew right now, don't wait until the last minute! 👇`,
      button: 'Renew Premium',
    },
    premiumExpiration_9: {
      title: `Hi 👋 Welcome to
Private Gate VPN!`,
      subtitle: `We're giving you {{count}} days free trial — no obligations, no credit card. Use it, test it, enjoy the free internet.

Just turn it on and feel the difference. If you like it — upgrade to a paid plan and stay protected 🚀`,
      description: '',
      button: 'Start using',
    },
    premiumExpired: {
      title: `😿 Your tariff has changed 
to free`,
      subtitle: `If you had a VPN through the app (X-Ray technology) installed, it stopped working. To continue using VPN via app you need to go back to Premium.
      
      For free access you need to install our alternative VPN protocol without apps in the settings of your device. You can do this via ‘Profile’.
      `,
      description:
        'To go back to the Premium plan and continue using the VPN without the headache, click ‘Extend Premium’ 👇',
      button: 'Extend Premium',
    },
    freeConnection: {
      title: `Your tariff is free`,
      subtitle: `Please get premium to configure a new connection.`,
      button: 'Extend Premium',
    },
    premiumExpired_7: {
      title: `VPN stopped working?`,
      subtitle: `That's because you have a free plan with a speed limit. For free access you need to install our alternative VPN protocol without apps. You can do this via ‘Profile’.`,
      description:
        'To ‘get things back to normal’ and continue to enjoy unlimited internet access, subscribe now 👇',
      button: 'Buy Premium',
    },
    speedLimit: {
      title: `VPN 
      stopped working?`,
      subtitle: `That's because you have a free plan with a speed limit. For free access you need to install our alternative VPN protocol without apps. You can do this via ‘Profile’.`,
      description:
        'To ‘get things back to normal’ and continue to enjoy unlimited internet access, subscribe now 👇',
      button: 'Buy Premium',
    },
    successfulPayment: {
      heading: 'Thank you for choosing us! Payment was successful',
      hint: 'To return to the home page click on the button:',
      button: 'Home',
    },
    failedPayment: {
      heading: 'Something went wrong. The payment was failed',
    },
    inProgressPayment: {
      heading: 'The payment is being made...',
    },
    noXrayPopup: "X-Ray VPN protocol (via app) is available only on Premium plan.\nTo continue using a VPN that cannot be blocked, please buy Premium plan.",
  },
  society: {
    facebook: 'https://www.facebook.com/groups/privategatevpn',
    telegram: 'https://t.me/privategatevpn',
    youtube: 'https://youtube.com/@PrivateGateEN?si=ovsYcKMzX25r-fSE',
  },
  links: {
    offer: 'https://privategatevpn.com/offer',
    privacyPolicy: 'https://privategatevpn.com/privacypolicy',
  },
  landing: {
    india: {
      badge: 'India pricing',
      title: 'Private Gate VPN',
      titleSubtitle: 'Special for India',
      subtitle:
        'Create an account from India and get local plans in INR after registration.',
      benefits: [
        'VPN that works in restrictive networks',
        'Fast setup on all your devices',
        'Local tariffs for India',
      ],
    },
    russia: {
      accountButton: 'Manage access',
      badge: '3 DAYS FREE',
      title: 'Private Gate VPN',
      titleSubtitle: 'VPN for Russia',
      subtitle:
        'Enter your email, confirm the code — and trial access will arrive directly in your inbox.',
      benefits: [
        'Connection without Telegram at the first step',
        '3 days of trial access',
        'Bind Telegram later to pay and keep access active',
      ],
      success: {
        badge: 'Access is ready',
        title: 'Your VPN is ready',
        description:
          'Select “Activate VPN”, choose your device, and follow the short guide.',
        descriptionWithEmail:
          'Access is ready. We also sent the secure setup link to {{email}}.',
        activateButton: 'Activate VPN',
        supportButton: 'Contact support',
        supportSubject: 'VPN issue',
      },
      returning: {
        title: 'Your connection',
        badge: 'Signed in',
        description: 'Open your VPN setup. Your access period has not changed.',
        noConnection: 'There is no available connection right now. Continue setup or purchase access in Telegram.',
        telegramButton: 'Continue in Telegram',
      },
      existingAccount: {
        title: 'This email is already registered',
        description:
          'An account with this email already exists. Continue and bind your account via Telegram.',
        telegramButton: 'Open Telegram',
        support: 'If you need help, contact us:',
      },
    },
  },
  navigation: {
    faq: 'FAQ',
    howToInstall: 'How to install',
    usefulLinks: 'Useful links',
    howItWorks: 'How it works',
    changePassword: 'Change password',
    enterPromoCode: 'Enter promo code',
    bringFriend: 'Bring a friend',
    support: 'Support',
    logout: 'Logout',
  },
  footer: {
    offer: 'Offer',
    privacyPolicy: 'Privacy Policy',
  },
  howItWorks: {
    howItWorks: {
      title: 'How it works',
      action: 'Start installation',
      description: `
      Private Gate is using X-Ray (VLESS) technology for highly censored regions. The latest VPN protocol that masks your internet traffic.
  
  ✅ Cannot be blocked
  ✅ Works always and everywhere
  ✅ Easy and fast installation
  ✅ Stable
  ✅ Works on any device

  You need to get the configuration of the VPN server and install it to the special app to make this protocol work.
  Start installing now by using instructions on this page:
  `,
    },
    gift: {
      title: '14 days Premium for Free',
      action: 'Switch to Premium',
      description: `Hi👋 Remember that we thoughtfully gave you 14 days of Premium from the start?

After the end of the trial period you can continue using the VPN for free, but you will need to install our alternative VPN (without apps). 
X-Ray VPN protocol (via app) is only available on Premium.

If you're happy with the current performance of our VPN, we recommend paying now and not thinking about it at the worst possible moment. 
To avoid breaking your head and keep turning on your VPN with one button, pay for your subscription now 
`,
    },
    free: {
      title: 'Free VPN',
      action: 'Buy VPN',
      description: `😿 Your plan has changed to FREE.

      If you had a VPN installed through the app (X-Ray technology), it stopped working. To continue using VPN through the app, you need to renew the Premium.

For free access, you need to install the alternative app-free VPN protocol in your device's settings. You can do this via creating new connection.

To return to the Premium plan and continue using VPN without headaches, click "Buy VPN" 👇
`,
    },
    bot: {
      title: 'Our Telegram bot',
      links: `Launch the bot at the link:--https://t.me/PrivateGateVPNbot`,
      description: `Not comfortable using it through your browser? We have a convenient bot in Telegram, through which you can also get VPN.

      `,
    },
    chat: {
      title: 'Our Telegram Channel and Chat',
      links: `📣 Our channel--https://t.me/privategatevpn ||
💬 Chat--https://t.me/privategatevpn_chat `,
      description: `Let's always stay connected 🤙

📣 Subscribe to our Telegram channel, where we share unique offers, promotions, news, and lifehacks for safe internet use.

💪 Join now and start receiving exclusive offers and benefits today!

We are waiting for you💚
`,
    },
    feedback: {
      title: 'Leave the feedback',
      links: `👉 All you have to do is write to our email: support@irs-lab.fr`,
      description: `If you have any ideas on how we can improve your Private Gate VPN adventure, please share them. 
We value your opinion and are here to help with any questions you may have. 

`,
    },
  },
  authentication: {
    notify: {
      successRegister: 'Account successfully created',
      userNotFound: 'User not found',
      onDisagreeance: 'You cannot sign up if you do not agree to the Offer and Privacy Policy'
    },
    login: {
      title: 'Login',
      noAccountYet: 'Don’t have an account yet?',
      register: 'Register',
      error: 'An error occured',
      loginButton: 'Log in',
    },
    registration: {
      title: 'Registration',
      agreement: 'By registering, you agree to the following documents:',
      and: 'and',
      otp: 'A one-time password for login will be sent to your email',
      offerAgreement: 'Offer',
      privacyPolicy: 'Privacy Policy',
      alreadyHaveAccount: 'Already have an account?',
      login: 'Login',
      next: 'Next',
      email: 'Email',
    },
    otp: {
      title: "Enter the confirmation code",
      code: "Check your inbox and spam folder for the verification code, sent to:",
      nocode: "Didn't get the code?",
      resend: "Resend",
      resendSuccess: "Code is resent successfully",
      next: "Next",
      wrong: "Invalid or expired code",
      provisioningError: "We couldn't set up your VPN. Please request a new code and try again later.",
      serviceError: "The service is temporarily unavailable. Please try again later.",
      wait: "You can send requests only once in 60 seconds. Wait ",
      seconds: " seconds to send new request"
    },
  },
  instruction: {
    step: 'Step',
    final: 'Final',
    image: 'Instruction',
  },
  provider: {
    name: {
      crypto: 'Payment with cryptocurrency',
      payze: 'International bank cards (with Payze)',
      ruCloudPayments: 'Russian bank cards',
      stripe: 'International bank cards (with Stripe)',
    },
  },
  connection: {
    full: 'Unable to create a new connection. The maximum number of connections has been reached. Delete one of the existing connections to create a new one',
    error: {
      create: 'There was an error connecting',
    },
    actions: 'Actions',
    downloadConfig: 'Download VPN configuration',
    whichDevice:
      'To which device do you want to download the VPN configuration file?',
    howToInstall: 'How to install',
    changeDevice: 'Change device',
    delete: 'Delete',
    confirm: {
      changeDevice: 'Are you sure you want to change the device?',
      delete: 'Are you sure you want to delete the connection?',
    },
    notify: {
      successDeleted: 'Connection successfully deleted',
    },
    list: 'Your devices and connections',
    add: 'add device',
    addNewDevice: 'Add a new device',
    cancelAdding: 'Close',
    name: 'Private Gate',
    server: 'Connection server',
    login: 'User name',
    password: 'Password',
  },
  country: {
    selectCountry: 'Select the country to connect to',
    selectCountryDescription:
      'The country to which your device will be connected, in the future you can change:',
    name: {
      empty: '🏳️ Not selected',
      kz: '🇰🇿 Kazakhstan',
      ka: '🇰🇿 Kazakhstan',
      ge: "🇩🇪 Germany",
      un: "🇦🇪 Arab Emirates",
      de: '🇩🇪 Germany',
      us: '🇺🇸 USA',
      ru: '🇷🇺 Russia',
      nl: '🇳🇱 Netherlands',
      sg: '🇸🇬 Singapore',
      fr: '🇫🇷 France',
      gb: '🇬🇧 United Kingdom',
      ae: '🇦🇪 Arab Emirates',
      tr: '🇹🇷 Turkey',
    },
    confirm: {
      change: 'Are you sure you want to change the country?',
    },
    notify: {
      successChanged: 'Country successfully changed',
    },
  },
  payment: {
    title: 'Payment',
    paymentMethod: 'Payment method',
    selectPaymentMethod: 'Select payment method',
    pay: 'Pay',
    openInBrowser: 'Open payment in browser',
    openBrowserHint: 'To continue your payment, open the page in your browser.',
    reopenBrowserHint: 'If the page did not open, try the link again. You do not need to create another payment.',
    disclaimer:
      'The currency of the debiting may differ, but the total actual amount does not change from this. To complete the payment, click on the "Pay" button.',
  },
  paymentReturn: {
    title: 'You have returned from the payment page',
    description: 'Check the payment result and your access period in the bot after confirmation by the payment service.',
    sameAccount: 'Use the same Telegram account you used to start the payment.',
    botAction: 'Return to the bot',
    botUnavailable: 'Open the bot you used to start the payment in your Telegram app.',
    telegramLoginUnavailable: 'Telegram login is currently unavailable. Sign in with your email.',
  },
  tariff: {
    name: {
      free: 'Free',
      freePremium: 'Free premium version',
      premium: 'Premium',
    },
    bandwidth: {
      bytes: 'Bits/s',
      kbytes: 'Kbits/s',
      mbytes: 'Mbits/s',
    },
    params: {
      remaining: 'Remaining',
      speed: 'Speed',
      deviceCount: 'Number of devices',
      discount: 'Discount',
      monthly: 'Monthly',
      free: 'Free',
      paidTo: 'Tariff paid until',
    },
    activateFor: 'Subscribe to Premium for',
    renewFor: 'Renew Premium for',
    renew: 'Renew Premium',
    change: 'Change tariff',
    connectFree: 'Connect for free',
    popularChoice: 'Popular choice',
    beneficial: 'Beneficial!',
    availableList: 'Available plans',
    current: 'Selected tariff',
  },
  promoCode: {
    title: 'Promo code',
    enter: 'Enter promo code',
    enterPromoCodeToGetOrExtendPremium:
      'Get or extend Premium tariff by entering a promo code',
    activateButton: 'Activate',
    yourPromoCode: 'Your promo code',
    confirmButton: 'Confirm',
    have: 'Have a promo code?',
    apply: 'Apply',
    error: 'The promo code is not correct or has already been activated',
    success: 'Your promo code is activated!',
  },
  device: {
    select: 'Select your device',
    selectDeviceToProtect:
      'Start safe internet surfing by selecting a device to protect',
  },
  xray: {
    device: 'Device',
    deviceSlots: '{{used}} of {{limit}} devices',
    devicePreparing: 'Preparing connection',
    deviceDeleting: 'Deletion is pending',
    deviceReview: 'Connection needs review',

    connection: 'App X-Ray',
    remaining: 'Remaining: ',
    duplicateConnection:
      'You have already created a reference key for the selected country. Use the key issued earlier!',
    createError: 'An error occurred while creating a connection',
    countryChangeHint:
      '⚠️ If you change VPN output country, the current connection will no longer work. On Premium tariff you can create 3 connections with different countries and use them simultaneously on different devices. Are you sure you want to change the output VPN country on the current connection?',
  },
  'non-app': {
    connection: 'NO-Apps',
  },
  guide: {
    app: {
      title: 'Follow the instructions',
      foxray: 'Download FoXray',
      hiddifynext: 'Download Hiddify-Next',
      linkKey: 'Link key'
    },
    description: 'Use the video guide',
    stepByStep: 'Step by step instructions:',
    mac: {
      app: {
        step: {
          1: {
            title: 'Install an app',
            description: {
              1: 'Install the app FoXray from App Store.',
              2: 'Install it on MacOS.',
            }
          },
          2: {
            title: 'Launch the app',
            description: {
              1: 'Open the installed app.',
              2: 'Agree with privacy policy if needed.'
            },
          },
          3: {
            title: 'Copy a VPN key',
            description: {
              1: 'Copy the VPN link-key for configuring VPN:',
            },
          },
          4: {
            title: 'Install the key',
            description: {
              1: 'Open the installed app.',
              2: 'Click a button “New Profile” in the main menu.',
              3: 'Press buttons “Add from clipboard” and "Allow pasting" if needed.',
            },
          },
          5: {
            title: 'Launch the VPN',
            description: {
              1: 'Click a button “Launch” for an imported key.',
              2: '“Allow” adding a VPN configuration if needed.\n\nCongratulations, the VPN is installed now!\nSurf thorugh the internet safely with Private Gate!',
            },
          },
        },
      },
    },
    windows: {
      app: {
        step: {
          1: {
            title: 'Install an app',
            description: {
              1: 'Install the app Hiddify from Microsoft Store.',
              2: 'Install it on Windows.',
            }
          },
          2: {
            title: 'Launch the app',
            description: {
              1: 'Open the installed app.',
              2: 'Agree with privacy policy if needed.'
            },
          },
          3: {
            title: 'Copy a VPN key',
            description: {
              1: 'Copy the VPN link-key for configuring VPN:',
            },
          },
          4: {
            title: 'Install the key',
            description: {
              1: 'Open the installed app.',
              2: 'Click a button “New Profile” in the main menu.',
              3: 'Press buttons “Add from clipboard” and "Allow pasting" if needed.',
            },
          },
          5: {
            title: 'Launch the VPN',
            description: {
              1: 'Click a button “Launch” for an imported key.',
              2: '“Allow” adding a VPN configuration if needed.\n\nCongratulations, the VPN is installed now!\nSurf thorugh the internet safely with Private Gate!',
            },
          },
        },
      },
    },
    linux: {
      app: {
        step: {
          1: {
            title: 'Install an app',
            description: {
              1: 'Install the app Hiddify-Next.',
              2: 'Install it on Linux.',
            }
          },
          2: {
            title: 'Open the app',
            description: {
              1: 'Investigate the properties of the app by right-clicking on the app and make it “Executable”.',
              2: 'Open the installed app.',
              3: 'Agree with privacy policy if needed.',
            }
          },
          3: {
            title: 'Insert a key',
            description: {
              1: 'Insert the key for configuring VPN:',
            }
          },
          4: {
            title: 'Install a VPN key',
            description: {
              1: 'Open the installed app Hiddify.',
              2: 'Click a button “New Profile” in the main menu.',
              3: 'Press a button “Add from clipboard”.',
              4: 'Push "Allow pasting" if needed.',
            }
          },
          5: {
            title: 'Launch the VPN',
            description: {
              1: 'Press “Launch” for an imported key.',
              2: '“Allow” adding a VPN configuration if needed.\n\nCongratulations, the VPN is installed now!\nSurf through the internet safely with Private Gate!',
            }
          }
        }
      }
    },
    iphone: {
      app: {
        step: {
          1: {
            title: 'Install an app',
            description: {
              1: 'Go to App Store',
              2: 'Install the app Hiddify.',
            },
          },
          2: {
            title: 'Launch the app',
            description: {
              1: 'Open the installed app.',
              2: 'Agree with privacy policy if needed.'
            },
          },
          3: {
            title: 'Copy a VPN key',
            description: {
              1: 'Copy the VPN link-key for configuring VPN:',
            },
          },
          4: {
            title: 'Install the key',
            description: {
              1: 'Open the installed app.',
              2: 'Click a button “New Profile” in the main menu.',
              3: 'Press a button “Add from clipboard”.',
              4: 'Push "Allow pasting" if needed.',
            },
          },
          5: {
            title: 'Launch the VPN',
            description: {
              1: 'Click a button “Launch” for an imported key.',
              2: '“Allow” adding a VPN configuration if needed.\n\nCongratulations, the VPN is installed now!\nSurf through the internet safely with Private Gate!',
            },
          },
        },
      },
    },
    android: {
      app: {
        step: {
          1: {
            title: 'Install an app',
            description: {
              1: 'Install the app Hiddify for Google Play.',
              2: 'Install it for Android.',
            },
          },
          2: {
            title: 'Launch the app',
            description: {
              1: 'Open the installed app.',
              2: 'Agree with privacy policy if needed.',
            },
          },
          3: {
            title: 'Copy a VPN key',
            description: {
              1: 'Copy the VPN link-key for configuring VPN:',
            },
          },
          4: {
            title: 'Install the key',
            description: {
              1: 'Open the installed app Hiddify.',
              2: 'Press a button “New Profile” in the main menu.',
              3: 'Click a button “Add from clipboard”.',
              4: 'Push "Allow pasting" if needed.',
            },
          },
          5: {
            title: 'Grant permissions',
            description: {
              1: 'Permit the request for connecting.',
              2: 'A VPN key is imported!',
            },
          },
          6: {
            title: 'Launch the VPN',
            description: {
              1: 'Click a button “Launch” for an imported key.',
              2: '“Allow” adding a VPN configuration if needed.\n\nCongratulations, the VPN is installed now!\nSurf through the internet safely with Private Gate!',
            },
          },
        },
      },
    },
    success: {
      mac: 'For Mac (macOS)',
      windows: 'For PC (Windows)',
      iphone: 'For iPhone (iOS)',
      android: 'For Android',
      linux: 'For PC (GNU Linux)'
    },
    gift: {
      title: 'Hooray, you have been activated Premium tariff for 7 days!',
      subtitle: 'This is a gift from Private Gate VPN',
      description:
        'Afterwards, you can use the free tariff with speed limitation or return to the advantages of Premium subscription',
      thanks: 'Thank you!',
    },
  },
  setup: {
    management: {
      title: 'Manage your access',
      description: 'Finish setup and turn on your VPN first. Then open the Telegram bot to manage your access and pay for an extension.',
      emailHint: 'If you registered by email, use the same email to sign in to your account. You can find your setup link in the email.',
      signIn: 'Sign in with the email for this connection to open the bot linked to the same account. If no email is linked, use the bot that gave you this link or contact support.',
      signInAction: 'Sign in to your account',
      switchAccountAction: 'Sign out and sign in with another email',
      openBot: 'Open the bot',
      preparing: 'Preparing your link…',
      ready: 'Your personal link is ready. Open the bot to continue with this account.',
      unavailable: 'Could not prepare the link. VPN setup is still available — try opening the bot later or contact support.',
    },
    expanded: {
      language: 'Instructions language',
      client: 'Application',
      unavailable: 'Value unavailable',
      show: 'Show: {{label}}',
      hide: 'Hide: {{label}}',
      copy: 'Copy: {{label}}',
      showValue: 'Show',
      hideValue: 'Hide',
      copyValue: 'Copy',
      copied: 'Copied',
      copyFailed: 'Could not copy. Select the value manually.',
      openApp: 'Open in app',
      valuesError: 'Could not load connection parameters. Retry or contact support.',
    },
    loading: 'Checking the secure link and loading instructions…',
    expired: {
      title: 'Link expired',
      description: 'Sign in with the same email to get a new setup link, or contact support. If no email is linked, return to the bot that gave you this link.',
      botAction: 'Open Private Gate Bot',
    },
    error: {
      title: 'Unable to open setup',
      description: 'Try again or contact support.',
    },
    instructionsError: {
      title: 'Instructions are temporarily unavailable',
      description:
        'The current instructions could not be loaded. Try again later or contact support.',
    },
    ready: {
      title: 'Your VPN is ready',
      description: 'Select your device and follow the instructions',
    },
    platformSelector: 'Select a device',
    recommendedApp: 'Recommended app: {{appName}}',
    version: 'Version: {{version}}',
    downloadConfig: 'Download configuration',
    retryAction: 'Try again',
    supportAction: 'Contact support',
  },
  referralLink: {
    title: "Bring a friend!",
    description: `Did you know, that you will have 7 days of Premium Subscription as a gift for every invited friend?

And it is not all:
🎁 If someone follows your link, they will have 7 days of Premium Subscription as a gift.
🎁 If invited pays for a subscription, they will have 1 month as a bonus, and you will have 3 months of Premium.`,
    link: "Here is your referral link:",
    userActivations: "Total amount of invited users:",
    userPaymentActivations: "Total amount of payments by invited users:",
    copyLink: "Copy link",
    copySuccess: "The link was successfully copied."
  }
};
